import { render } from "./PatientNurseBio.vue?vue&type=template&id=ce8e2d5e&scoped=true"
import script from "./PatientNurseBio.vue?vue&type=script&lang=js"
export * from "./PatientNurseBio.vue?vue&type=script&lang=js"

import "./PatientNurseBio.vue?vue&type=style&index=0&id=ce8e2d5e&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ce8e2d5e"]])

export default __exports__